<!-- 教育局 区级-课程审核 -->
<template>
<div>
    <div class="index" v-if="!detail.show">
        <div class="title">
            <div class="span1">
                <span>{{$route.name}}</span>
            </div>
        </div>

        <div>
			<el-form :inline="true" :model="queryParams" label-width="70px">
				<el-form-item label="" label-width="90px">
                    <el-input v-model="queryParams.cname" placeholder="请输入课程名称"></el-input>
                </el-form-item>
				<el-form-item label="" label-width="90px">
                    <el-input v-model="queryParams.oname" placeholder="请输入报审单位名称"></el-input>
                </el-form-item>
				<el-form-item label="">
                    <!-- <el-select v-model="queryParams.typeId" clearable placeholder="选择课程分类" class="label">
                        <el-option v-for="item in courseType" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select> -->
					<coure-type @setCourseType="setCourseType"  type="seach"></coure-type>
                </el-form-item>
				 <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
                </el-form-item>
			</el-form>

            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="cname" label="课程名称" align="center">
                    </el-table-column>
                    <el-table-column prop="typeName" label="课程分类" align="center">
                    </el-table-column>
                    <el-table-column prop="coverArea" label="覆盖区域" align="center">
                    </el-table-column>
                    <el-table-column prop="orgName" label="报审单位" align="center">
                    </el-table-column>
                    <el-table-column header-align="center" align="center" label="操作" width="200" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="toDetail(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
    <Detail :info.sync="detail.info" v-show="detail.show" @to-index="toIndex" @to-init="getDataList"></Detail>
</div>
</template>
<script>
import educationApi from '@/api/education/index.js'
import { getDetail } from "@/api/mechanismApi/curriculum";
export default {
    components:{
        Detail: ()=>import('./detail.vue'),
		coureType: () => import("@/views/components/coureType.vue"),
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				cname:'',
				oname:'',
				typeId:'',
				subclassId: "",
				state:'',
			},
			courseType:JSON.parse(sessionStorage.getItem('courseType')) || [],
			tableData: [],
            detail:{
                info:{},
                show:false,
            },
			school_info:JSON.parse(sessionStorage.getItem('classList')),
		}
	},
	watch:{

	},
	created() {
		this.getDataList();
	},
	methods: {
		async getDataList() {
			let params = {
				cname:this.queryParams.cname,
				oname:this.queryParams.oname,
				typeId:this.queryParams.typeId,
				subclassId:this.queryParams.subclassId,
				state:this.queryParams.state,
				source:'0',
				pageNum:this.pageNum,
				pageSize:this.pageSize,
			}
			let res = await educationApi.getEducationCourseWiteauditlist(params);
			if(res.result==='000000'){
				this.tableData=res.data?.list || [];
				this.totalPage=res.data?.total || 0;
			}
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        async toDetail(item){
			let params = {
				id: item.cid,
			};
			let paramsData= {
				cid: item.cid,
				orgId:sessionStorage.getItem("orgId"),
			};
			var { result,data } = await getDetail(params);
			let res= await educationApi.getEducationCourseauditrecord(paramsData);
			if (result == "000000") {
				this.detail.info = data;
				if(res.result==='000000'){
					this.detail.info.operateList=res.data || [];
				}
				this.detail.show = true;
			} else {
				this.$message({
				type: "error",
				message: "获取信息失败",
				});
			}
        },
		setCourseType(data) {
		  this.queryParams.typeId = data.typeId || "";
		  this.queryParams.subclassId = data.subclassId || "";
		},
        toIndex(){
            this.detail.show=false;
        },
	},
	mounted() {

	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
			margin-right: 30px;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 160px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
</style>
